export const commentHeader = `
/**
* Generated by @proofkit/typegen package
* https://proofkit.dev/docs/typegen
* DO NOT EDIT THIS FILE DIRECTLY. Changes may be overritten
*/

// @generated
// prettier-ignore
/* eslint-disable */

`;

export const overrideCommentHeader = `
/**
* Put your custom overrides or transformations here.
* Changes to this file will NOT be overwritten.
*/
`;

export const varname = (name: string) => name.replace(/[^a-zA-Z0-9_]/g, "");

export const defaultEnvNames = {
  apiKey: "OTTO_API_KEY",
  ottoPort: "OTTO_PORT",
  username: "FM_USERNAME",
  password: "FM_PASSWORD",
  server: "FM_SERVER",
  db: "FM_DATABASE",
};
